import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BaseTypeTier } from "../../../models/enums";
import { GearTierType } from '../../../models/item-data-models';

@Component({
  selector: 'app-gear-tier-icon',
  imports: [],
  templateUrl: './gear-tier-icon.component.html',
  styleUrl: './gear-tier-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GearTierIconComponent {
  iconMap: Record<BaseTypeTier, string> = {
    [BaseTypeTier.Basic]: 'icon-star-1',
    [BaseTypeTier.Advanced]: 'icon-star-2',
    [BaseTypeTier.Expert]: 'icon-star-3',
    [BaseTypeTier.Elite]: 'icon-star-4',
    [BaseTypeTier.Master]: 'icon-star-5'
  };

  colorClassMap: Record<BaseTypeTier, string> = {
    [BaseTypeTier.Basic]: 'tier-basic-color',
    [BaseTypeTier.Advanced]: 'tier-advanced-color',
    [BaseTypeTier.Expert]: 'tier-expert-color',
    [BaseTypeTier.Elite]: 'tier-elite-color',
    [BaseTypeTier.Master]: 'tier-master-color'
  };

  tier = input<BaseTypeTier | GearTierType>(BaseTypeTier.Basic);

  iconClass = computed(() => {
    return this.iconMap[this.tier() as BaseTypeTier] || 'icon-star-1';
  });

  colorClass = computed(() => {
    return this.colorClassMap[this.tier() as BaseTypeTier] || 'tier-basic-color';
  });

  spanClass = computed(() => `${this.iconClass()} ${this.colorClass()}`);
}
